import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Table from 'src/components/Table/Table'
import { Asset } from 'src/types'

const TableAssets = ({ assets }: { assets: Asset[] }) => {
  const history = useHistory()
  const handleSelect = row => history.push('/assets/' + (row.slug || row.activeID))
  const isSec = useSelector((s: any) => s?.user?.customerId?.includes('SEC'))

  const cols = [
    { name: 'prinexId' },
    { name: 'province' },
    { name: 'address' }
  ]
  if (isSec) cols.push({ name: 'customerId' })

  return (
    <Table
      handleSelect={handleSelect}
      name={'assets'}
      className={isSec ? 'sec' : null}
      data={assets}
      columns={cols}
    />
  )
}

export default TableAssets
